export default function StandingsDriverPointsCell({ position, points }) {
  const data = {
    color: '',
    bgColor: 'bg-neutral-blue-800!',
    borderColor: 'border-neutral-blue-800!',
  }

  switch (position) {
    case 1:
      data.color = 'medals-gold'
      data.bgColor = 'bg-[#FF99004D]!'
      data.borderColor = 'border-medals-gold!'
      break
    case 2:
      data.color = 'medals-silver'
      data.bgColor = 'bg-[#F2F2F24D]!'
      data.borderColor = 'border-medals-silver!'
      break
    case 3:
      data.color = 'medals-bronze'
      data.bgColor = 'bg-[#FF72224D]!'
      data.borderColor = 'border-medals-bronze!'
      break
  }

  return (
    <div
      className={`grid h-full min-h-[42px] w-[42px] items-center justify-center rounded-sm border text-sm font-medium tabular-nums md:min-h-[68px] md:w-[68px] md:text-h-6-sm ${data.borderColor} ${data.bgColor}`}
    >
      {points}
    </div>
  )
}
